import styled from 'styled-components'
import { GIVONIC } from '../../styles/fonts'

// Size configurations
const sizeList = {
  small: {
    fontFamily: GIVONIC.regular,
    fontWeight: '600',
    fontSize: 0.9,
    lineHeight: '14px',
    letterSpacing: 0.2,
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  medium: {
    fontFamily: GIVONIC.bold,
    fontWeight: '700',
    fontSize: 1.2,
    lineHeight: '18px',
    letterSpacing: 0.001,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
};

export type GradientProps = {
  size: 'small' | 'medium'
  $gradientBackground?: string
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GradientContainer = (styled.div<GradientProps>`
  padding: ${props => `${sizeList[props.size].paddingVertical}px ${sizeList[props.size].paddingHorizontal}px`};
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.$gradientBackground || 'linear-gradient(117.03deg, #3C53D7 0.01%, #1A1B6E 90%)'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export type BetaTextProps = {
  size: 'small' | 'medium'
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BetaText = (styled.span<BetaTextProps>`
  position: relative;
  bottom: -1px;
  font-family: ${props => sizeList[props.size].fontFamily};
  font-weight: ${props => sizeList[props.size].fontWeight};
  font-size: ${props => `${sizeList[props.size].fontSize}rem`};
  color: white;
  line-height: ${props => sizeList[props.size].lineHeight};
  letter-spacing: ${props => `${sizeList[props.size].letterSpacing}px`};
  text-transform: uppercase;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
